import { css } from 'lit';
export default css `
    :host {
        --input-background-color: var(--color-ui-08);
        --input-border-color: var(--color-ui-04);
        --input-box-shadow: none;
        --input-cursor: initial;
        --input-focus-border-color: var(--color-primary);
        --input-padding: var(--spacing-s) var(--spacing-m);
        --input-validation-color: var(--color-primary);
        --input-text-transform: none;

        display: block;
        position: relative;
    }
`;
